import { CarcassonneModuleId, ModuleDefinition } from '../types';

export const carcassonneModules: ModuleDefinition[] = [
  {
    id: 'base',
    name: 'Gra podstawowa',
    shortName: 'Baza',
    editionTag: 'C3',
    category: 'base',
    description: 'Najnowsza polska gra podstawowa, grafika C3.',
    defaultEnabled: true,
    alwaysOn: true,
    status: 'ready',
  },
  {
    id: 'river',
    name: 'Rzeka',
    shortName: 'Rzeka',
    editionTag: 'C3',
    category: 'core',
    description: 'Zastępuje kafelek startowy sekwencją kafelków rzeki.',
    defaultEnabled: true,
    status: 'ready',
  },
  {
    id: 'abbot',
    name: 'Opat',
    shortName: 'Opat',
    editionTag: 'C3',
    category: 'core',
    description: 'Dodatkowa figura na klasztory i ogrody z wcześniejszym wycofaniem.',
    defaultEnabled: true,
    status: 'ready',
  },
  {
    id: 'major-01-inns-cathedrals',
    name: 'Karczmy i Katedry',
    shortName: 'Karczmy',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Karczmy, katedry, duży meeple i komponenty dla 6. gracza (C3.1 2025).',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-02-traders-builders',
    name: 'Kupcy i Budowniczowie',
    shortName: 'Kupcy',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Towary, budowniczy i świnia według zasad C3.1.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-03-dragon-fairy',
    name: 'Wróżka i Smok',
    shortName: 'Smok',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Smok (dwa ruchy proste), wróżka i magiczny portal — nie mylić z Księżniczką i Smokiem.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-04-towers-thieves',
    name: 'Wieże i Złodzieje',
    shortName: 'Wieże',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Wieże ze strażnikami i symbolami złodzieja — bez porywania meepli.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-05-messengers-mayors',
    name: 'Kurierzy i Burmistrzowie',
    shortName: 'Burmistrzowie',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Ratusze, burmistrzowie, kurierzy i strachy na wróble (C3.1).',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-06-jousts-crests',
    name: 'Turnieje i Godła',
    shortName: 'Turnieje',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Turnieje, godła i kafelki nagród — nie mylić z Hrabią, Królem i Rzeką.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-07-siege-defense',
    name: 'Oblężenie i Obrona',
    shortName: 'Oblężenie',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Twierdza, stanowiska obrony i katapulty — nie mylić z Katapultą C1/C2.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-08-castles-bridges',
    name: 'Zamki i Mosty',
    shortName: 'Zamki',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Mosty, zamki i stodoły — bez bazarów z dawnego dodatku.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-09-sheep-shepherds',
    name: 'Pasterze i Owce',
    shortName: 'Pasterze',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Pasterze, stada, wilki, gęsi i winnice — bez wzgórz.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'major-10-circus-artists',
    name: 'Cyrk i Artyści',
    shortName: 'Cyrk',
    editionTag: 'C3.1',
    category: 'major',
    description: 'Place cyrkowe, występy, akrobaci i dyrektorka cyrku.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mini-01-flying-machines',
    name: 'Maszyny latające',
    shortName: 'Maszyny',
    editionTag: 'C3',
    category: 'mini',
    description: 'Lot meepla w kierunku maszyny na odległość z kości.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mini-02-messengers',
    name: 'Kurierzy (minidodatek)',
    shortName: 'Wiadomości',
    editionTag: 'C3',
    category: 'mini',
    description: 'Tor wiadomości Big Box — nie mylić z Kurierami i Burmistrzami C3.1.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mini-03-ferries',
    name: 'Promy',
    shortName: 'Promy',
    editionTag: 'C3',
    category: 'mini',
    description: 'Promy łączące odcinki dróg przy jeziorach.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mini-04-goldmines',
    name: 'Kopalnie złota',
    shortName: 'Złoto',
    editionTag: 'C3',
    category: 'mini',
    description: 'Sztabki złota zbierane przy ukończeniu obszarów.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mini-05-mage-witch',
    name: 'Mag i Wiedźma',
    shortName: 'Mag',
    editionTag: 'C3',
    category: 'mini',
    description: 'Neutralne figury zmieniające wartość dróg i miast.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mini-06-robbers',
    name: 'Bandyci',
    shortName: 'Bandyci',
    editionTag: 'C3',
    category: 'mini',
    description: 'Bandyci na torze punktacji śledzący rywali.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mini-07-crop-circles',
    name: 'Kręgi w zbożu',
    shortName: 'Kręgi',
    editionTag: 'C3',
    category: 'mini',
    description: 'Efekty zmuszające do dokładania lub zdejmowania figur danego typu.',
    defaultEnabled: false,
    status: 'ready',
  },
  {
    id: 'mists-over-carcassonne',
    name: 'Mgła nad Carcassonne',
    shortName: 'Mgła',
    editionTag: 'C3',
    category: 'standalone',
    description:
      'Pełna kooperacyjna gra z poziomami 1–6 oraz wariant Duchów, Zamków i Cmentarzy do klasycznego Carcassonne. Domyślnie wyłączona.',
    defaultEnabled: false,
    status: 'ready',
  },
];

export const ALL_MODULE_IDS: CarcassonneModuleId[] = carcassonneModules.map(
  (m) => m.id
);

export const LEGACY_MISTS_MODULE_ID = 'mists-compatibility';

export function migrateModuleId(id: string): CarcassonneModuleId | null {
  if (id === LEGACY_MISTS_MODULE_ID) return 'mists-over-carcassonne';
  if (ALL_MODULE_IDS.includes(id as CarcassonneModuleId)) {
    return id as CarcassonneModuleId;
  }
  return null;
}

export function getModuleById(
  id: CarcassonneModuleId
): ModuleDefinition | undefined {
  return carcassonneModules.find((m) => m.id === id);
}

export function getDefaultEnabledModuleIds(): CarcassonneModuleId[] {
  return carcassonneModules
    .filter((m) => m.defaultEnabled && m.status === 'ready')
    .map((m) => m.id);
}

export function getConfigurableModules(): ModuleDefinition[] {
  return carcassonneModules.filter((m) => m.status === 'ready');
}

export function isModuleActivatable(id: CarcassonneModuleId): boolean {
  return getModuleById(id)?.status === 'ready';
}
